import { createApiInstance } from "./apiInstance";
import { apiCall } from "./apiCall";
import { Method } from "axios";
import { decrypt } from "dotenv";
import { getAvailablePaymentTypes } from '../../utils/payment_types';

const cardApi = createApiInstance(process.env.REACT_APP_SERVER_MPGS_URL || "https://onepay-mpgs-live.onepayapi.lk/api/v3/");

export const cardPaymentApiCall = (
  url: string,
  method: Method = 'GET',
  data: any = null,
  header: string | null = null,
  encrypt: boolean = false,
  decrypt: boolean = false
): Promise<any> => {
  return apiCall(cardApi, url, method, data, header, encrypt,decrypt);
};
